// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3177":"118111bb","3216":"9b93c0b8","3613":"dcdd786b","5215":"dcdd786b","5960":"118111bb"}[chunkId] + ".chunk.css";
};